howspace.team = (() => {
    'use strict';

    real.onTierReady(real.TIER_2, () => {
        real.events.on('team:updated', function (notification) {
            if (notification.object.team.name) {
                $('.team-name[data-team-id="' + notification.object.team.id + '"]').html(
                    notification.object.team.name
                );
            }

            if (notification.object.team.avatar_html) {
                howspace.components.avatar.updateContent(
                    $('.avatar[data-team-id="' + notification.object.team.id + '"]'),
                    notification.object.team.avatar_html
                );
            }
        });
    });
    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initEditProfilePictureModal = (modal, modalOpener) => {
        const teamId = $(modalOpener).data('team-id');

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_INITIALIZING, e => {
            real.button.loading($(modal).find('.save-image-button'));
        });

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_READY, e => {
            real.button.reset($(modal).find('.save-image-button'));
        });

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_SAVE, e => {
            const canvas = e.detail.data;
            const formData = new FormData();
            const token = real.uid();
            formData.append('upload_process_metadata', JSON.stringify({
                token: token
            }));

            // Wait until the image is stored to S3, then save the team.
            const handleStored = (notification) => {
                if (notification.object.uploadedfile?.upload_process_metadata?.token === token) {
                    real.events.off('workspace:uploadedfile:stored', handleStored);
                    real.ajax.json(real.baseUri + '/api/team/' + teamId, {
                        type: 'POST',
                        data: JSON.stringify({
                            avatar: notification.object.uploadedfile.id
                        }),
                        success: () => {
                            howspace.components.modal.close(modal);
                        }
                    });
                }
            };
            real.events.on('uploadedfile:stored', handleStored);

            canvas.toBlob(blob => {
                formData.append('file', blob, teamId + '-avatar.png');

                real.ajax(real.baseUri + '/api/uploadedfiles', {
                    type: 'POST',
                    data: formData,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                });
            }, 'image/png');
        });
    };

    const checkSaveButton = function (modal) {
        const hasName = real.trim(modal.find('#team-name-input').val()) !== '';
        modal.find('.modal-footer .button-action').prop('disabled', !hasName);
    };

    const initTeamEditorModal = (modal) => {
        modal = $(modal);

        real.input.focus(modal.find('#team-name-input'));

        modal.find('#team-name-input').on('input', function (e) {
            if (real.trim(modal.find('#team-name-input').val()) === '') {
                modal.find('.modal-footer .button-action').prop('disabled', true);
            } else {
                modal.find('.modal-footer .button-action').prop('disabled', false);
            }

            checkSaveButton(modal);
        });

        modal.on(howspace.components.userPicker.USER_ADDED, () => {
            checkSaveButton(modal);
        });
        modal.on(howspace.components.userPicker.USER_REMOVED, () => {
            checkSaveButton(modal);
        });
    };

    const initProfileModal = modal => {
        modal = $(modal);

        initTeamEditorModal(modal);

        modal.find('.modal-footer .save-btn').on('click', function (e) {
            const btn = $(this);
            real.button.loading(btn, modal);

            const dataPayload = real.form.getDataPayload(modal);

            real.ajax.json(real.baseUri + '/api/team/' + modal.data('team-id'), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    // This is handled by events.
                    real.button.reset(btn, modal);
                    howspace.components.modal.close(modal[0]);
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    const initCreateModal = (modal, modalOpener) => {
        modal = $(modal);

        initTeamEditorModal(modal);

        modal.find('.modal-footer #create-team-btn').on('click', e => {
            const btn = $(e.target);
            btn.prop('disabled', true);

            real.button.loading(btn, modal);

            const dataPayload = real.form.getDataPayload(modal);

            real.ajax.json(real.baseUri + '/api/teams', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: response => {
                    real.button.reset(btn, modal);
                    // Dispatch a custom event to notify that a team has been created.
                    howspace.dispatchEvent(modalOpener, 'team-has-been-created', {
                        team: response
                    });
                    howspace.components.modal.close(modal[0]);
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    const deleteAvatar = (btn, teamId) => {
        const dataPayload = {
            avatar: null
        };

        real.ajax.json(real.baseUri + '/api/team/' + teamId, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                $('.delete-team-avatar-btn').addClass('d-none');
            },
            complete: () => {
                real.button.reset(btn, btn.closest('.modal'));
            }
        });
    };

    real.dom.$body.on('click', '.delete-team-avatar-btn', (e) => {
        const btn = $(e.currentTarget);
        const teamId = btn.data('team-id');

        real.button.loading(btn, btn.closest('.modal'));

        deleteAvatar(btn, teamId);
    });

    return {
        initTeamEditorModal: initTeamEditorModal,
        initProfileModal: initProfileModal,
        initEditProfilePictureModal: initEditProfilePictureModal,
        initCreateModal: initCreateModal
    };

})();
